// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chef-calendar{border:0!important;width:100%!important}.chef-calendar .day:hover:not(.blank):not(.disabled),.chef-calendar .selected{background-color:#22428a!important;border-radius:10rem!important;border-width:0!important;color:#fff!important}.chef-calendar .disabled{-webkit-text-decoration:line-through;text-decoration:line-through}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
